import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { pseudoBlock } from '../../../utils/mixins';
import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';
import { TabsHorizontal, TabHorizontal } from '../TabsHorizontal';

export const StyledWrapper = styled.div`
  position: relative;

  &:after {
    ${pseudoBlock()};
    top: 0;
    right: 0;
    ${mediaqueries.greaterThan('desktopBig')`
        display: none;
    `};
    /* background-image: linear-gradient(
      to left,
      rgba(231, 231, 231, 0.95),
      rgba(231, 231, 231, 0)
    ); */
  }

  ${props =>
    !props.menuWithScroll &&
    mediaqueries.greaterThan('desktopBig')`
      max-width:  ${rem('1230px')};
      margin: ${rem('20px')} auto 0;
  `};
`;

/* Contenedor principal */
export const BoxGeneral = styled.div`
  display: flex;
  position: relative;
  // background-color: ${props => props.theme.colors.grayLighter};
  // border-top: ${rem('2px')} solid ${props => props.theme.colors.dark};
  // width: 100vw;
  // overflow-x: auto;
  :before {
    ${pseudoBlock()};
  }
  :after {
    ${pseudoBlock()};
    right: 0;
  }

  ${props =>
    props.menuWithScroll
      ? mediaqueries.greaterThan('desktopBig')`
    width: auto;   
    
  `
      : mediaqueries.greaterThan('desktopBig')`
      border: none;
      background-color: transparent;
      width: auto;
      overflow: hidden;
      :after,:before {
        display: none;
      }
  `};
`;

/*  Botón despliega menú */
export const ButtonAction = styled.button`
  background-color: ${props => props.theme.colors.dark};
  border: 0;
  color: ${props => props.theme.colors.light};
  cursor: pointer;
  display: none;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('2px')};
  min-width: ${rem('145px')};
  outline: 0;
  padding: ${rem('8px')} ${rem('20px')} ${rem('8px')} ${rem('56px')};
  position: relative;
  text-transform: uppercase;
  z-index: 2;
  ${props =>
    !props.menuWithScroll &&
    mediaqueries.greaterThan('desktopBig')`
      display: block;
  `};
`;

/* Detalle líneas */
export const detail = css`
  content: '';
  height: ${rem('2.5px')};
  position: absolute;
  transform: translate(-13px, 0);
  transition: all 0.3s ease-in-out;
`;

/* Líneas dentro de botón */
export const Lines = styled.div`
  background-color: ${props => props.theme.colors.light};
  height: ${rem('3px')};
  position: absolute;
  top: ${rem('9px')};
  left: ${rem('20px')};
  width: ${rem('26px')};
  :after {
    ${detail};
    background-color: ${props => props.theme.colors.light};
    top: ${rem('8px')};
    right: ${rem('-8px')};
    width: ${rem('21px')};
  }
  :before {
    ${detail};
    background-color: ${props => props.theme.colors.light};
    top: ${rem('16px')};
    right: ${rem('-4px')};
    width: ${rem('17px')};
  }
  ${props =>
    props.selected &&
    css`
      :after {
        transform: translate(${rem('-8px')}, 0);
      }
      :before {
        transform: translate(${rem('-4px')}, 0);
      }
    `};
`;

/* Botones */
export const buttons = `
  box-sizing: content-box;
  display: none;
  height: ${rem('37px')};
  padding: 0 ${rem('25px')};
  top: 0;
  width: ${rem('7px')};
`;

export const StyledArrowLeft = styled(ButtonArrowLeft)`
  background-image: linear-gradient(to right, rgba(76, 76, 76, 0), #4c4c4c);
  ${buttons};
  ${mediaqueries.greaterThan('desktopBig')`
    display: none;
    left: ${rem('145px')};
  `};
`;

export const StyledArrowRight = styled(ButtonArrowRight)`
  display: none;
  background-image: linear-gradient(to left, rgba(76, 76, 76, 0), #4c4c4c);
  ${buttons};
  ${mediaqueries.greaterThan('desktopBig')`
    display: none;
  `};
`;

export const ItemSelected = styled.p`
  display: none;
  ${props =>
    !props.menuWithScroll &&
    mediaqueries.greaterThan('desktopBig')`
    margin: 0;
    font-family: ${props => props.theme.fonts.medium};
    font-size: 0.75rem;
    background-color: ${props => props.theme.colors.graySad};
    border-color: ${props => props.theme.colors.dark};
    color: ${props => props.theme.colors.light};
    position: absolute;
    left: 0;
    transition: 0.3s;
    transform: translateX(${rem('0px')}); 
    padding: ${rem('6px')} 1rem ${rem('6px')} 1rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    z-index: 1;

    ${props =>
      props.text === 'Mis cosas' &&
      css`
        transform: translateX(${rem('145px')});
      `}

      ${props =>
        props.text === 'Nuestras cosas' &&
        css`
          transform: translateX(${rem('190px')});
        `}  

    ${props =>
      props.selected &&
      css`
        transform: translateX(${rem('-145px')});
      `}`};
`;

/* Reestilo de Tabs componente */
export const StyledTabs = styled(TabsHorizontal)`
  :after,
  :before {
    display: block;
  }
  ${props =>
    !props.menuWithScroll &&
    mediaqueries.greaterThan('desktopBig')`
    width: auto;
    :after,
    :before {
      display: none;
    }
    transition: 0.3s;
    transform: translateX(${props => props.posX}px); 
  `};
`;

export const StyledSearchRedesign = styled.div`
  margin: 0 20 0 0;
  ${mediaqueries.lessThan('desktopBig')`
    margin: ${props => props.show && '40 0 0 0'};
  `}
`;

export const StyledAccessRedesign = styled.div`
  width: ${props => !props.show && '27%'};
  max-width: ${props => !props.show && '27%'};
  box-shadow: 1px 3px 5px rgb(0 0 0 / 30%);
  // height: 100%;
  margin: 0 20 0 0;
  ${mediaqueries.lessThan('desktopBig')`
    margin: ${props => props.show && '0 0 0 0'};
  `}
  ${mediaqueries.greaterThan('desktopBig')`
    width: ${props => (!props.show ? '27%' : '25%')};
  `};
`;

export const StyledMenuRedesign = styled.div`
  box-shadow: 1px 3px 5px rgb(0 0 0 / 30%);
  padding: 1.5625rem 0.5rem 1rem 0.5625rem;
  height: 93.3%;
  // margin: 0 20 0 0;
  ${mediaqueries.lessThan('desktopBig')`
    margin: ${props => props.show && '30 0 30 0'};
    height: fit-content;
  `}
  ${mediaqueries.greaterThan('desktopBig')`
    width: 67%;
  `}
`;

export const StyledElementsRedesign = styled.div`
  background-color: ${props => props.theme.colors.light};
  border-bottom: 0;
  color: ${props => props.theme.colors.dark};
  margin: 0;
  padding: ${rem('7px')} ${rem('20px')};
  :before {
    content: '';
    height: ${rem('13px')};
    left: 0;
    top: ${rem('13px')};
    width: ${rem('2px')};
  }
  &:first-child:before {
    display: none;
  }
  ${props =>
    props.show &&
    props.show === true &&
    mediaqueries.lessThan('desktopBig')`
      overflow-y: auto;
  `};
  ${props =>
    props.active &&
    `
      background-color: ${props.theme.colors.dark};
      color: ${props.theme.colors.light};
      :before {
        content: none;
      }
    `};
  ${mediaqueries.greaterThan('mobile')`
    :before {
      top: ${rem('18px')};
    }
`};
  ${props =>
    !props.menuWithScroll
      ? mediaqueries.greaterThan('desktopBig')`
    border: 0;
    width: 100%;
    color: ${props => props.theme.colors.light};
    font-size: ${props => props.theme.fontSize.xsmall};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: center;
    :before {
      content: none;
    }
    &:hover{
      cursor: pointer;
    }
 
    ${props =>
      props.active &&
      css`
        background-color: ${props => props.theme.colors.graySad};
        &:hover {
          cursor: default;
        }
      `};
  `
      : mediaqueries.greaterThan('desktopBig')`
  :before {
      top: 13px
    } 
    &:hover:before{
      display: none;
    }  
  `};
`;

/* Reestilo de Tab componente */
export const StyledElementsList = styled(TabHorizontal)`
  background-color: ${props => props.theme.colors.graySad};
  color: ${props => props.theme.colors.light};
  border-bottom: 0;
  margin: 0;
  padding: ${rem('7px')} ${rem('20px')};
  ${mediaqueries.lessThan('mobile')`
    width: inherit;
  `};
  :before {
    content: '';
    height: ${rem('13px')};
    left: 0;
    top: ${rem('13px')};
    width: ${rem('2px')};
  }
  &:first-child:before {
    display: none;
  }
  ${props =>
    props.active &&
    `
      background-color: ${props.theme.colors.dark};
      color: ${props.theme.colors.light};
      :before {
        content: none;
      }
    `};
  ${mediaqueries.lessThan('mobile')`
    :before {
      background-color: transparent;
    }
  `};
  ${mediaqueries.greaterThan('mobile')`
    :before {
      // top: ${rem('18px')};
    }
  `};
  ${props =>
    !props.menuWithScroll
      ? mediaqueries.greaterThan('desktopBig')`
    border: 0;
    width: 100%;
    color: ${props => props.theme.colors.light};
    font-size: ${props => props.theme.fontSize.xsmall};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    :before {
      content: none;
    }
    &:hover{
      cursor: pointer;
    }
 
    ${props =>
      props.active &&
      css`
        background-color: ${props => props.theme.colors.dark};
        &:hover {
          cursor: default;
        }
      `};
  `
      : mediaqueries.greaterThan('desktopBig')`
  :before {
      top: 13px
    } 
    &:hover:before{
      display: none;
    }  
  `};
`;
